import { FC, useEffect, useRef, useState } from "react";
import { ReactComponent as ArrowTopSvg } from "images/top-arrow.svg";
import { ReactComponent as ActionIconSvg } from "images/ActionMenuIcon.svg";
import { ReactComponent as EditorIconSvg } from "images/EditorIcon.svg";
import { ReactComponent as TrashCanSvg } from "images/TrashCan.svg";
import { OkvedSectionInterface } from "toolkit/codes/codes.types";
import DropSelect from "components-new/DropSelect";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { deleteCode, setCode } from "toolkit/codes/codes.thunks";
import ModalPortal from "components-new/ModalPortal";
import { selectRow, setEditCodeModal } from "toolkit/codes/codes.slice";
import { Button } from "components/shared";
import { useLocation } from "react-router-dom";
import NewCheckBox from "components-new/NewCheckBox";
import cn from "classnames";
import styles from "./TableBody.module.sass";
import { snackWrapper } from "../../../../../helpers";
import {directoryAPI} from "../../../../../libs/apiClient/Directory";

interface BodyRowProps {
	row: OkvedSectionInterface;
	isMain?: boolean;
	outline: (id: string, isMain: boolean) => string;
	ruleEdit: boolean;
}

const BodyRow: FC<BodyRowProps> = ({ row, isMain, outline, ruleEdit }) => {
	const location = useLocation();
	const dispatch = useAppDispatch();
	const { isEdit, selectedRows, code } = useAppSelector((state) => state.codes);

	const actionsRef = useRef(null);

	const [active, setActive] = useState<boolean>(false);
	const [actionsVisible, setActionsVisible] = useState<boolean>(false);

	useOutsideAlerter(actionsRef.current, () => setActionsVisible(false));
	useEffect(() => {
		function some(arr: any[], field: string) {
			return arr.map((_) => _[field]);
		}

		if (isEdit || location.state?.outline) {
			let codes: any[] = [];

			row.codes.forEach((_) => {
				if (_.codes.length) {
					codes.push(_.code);
					codes.push(some(_.codes, "code"));
				} else {
					codes.push(_.code);
				}
			});
			codes = codes.flat();
			for (let i = 0; i < codes.length; i++) {
				const item = codes[i];
				if (selectedRows.includes(item) || item === location.state?.outline?.id) {
					setActive(true);
					break;
				}
			}
		} else {
			setActive(false);
		}
		//eslint-disable-next-line
	}, [row, isEdit]);

	const handleEditCode = () => {
		if (isMain) {
			directoryAPI.okvedSectionDetail(row.code).then((data) => {
				dispatch(
					setEditCodeModal({
						visible: true,
						inputValues: {
							code: data.data.code,
							name: data.data.name,
							description: data.data.description,
							sectionCode: data.data.code,
						},
						isMain: true,
					}),
				);
			});
		} else {
			directoryAPI.okvedSectionDetail(row.code).then((data) => {
				dispatch(
					setEditCodeModal({
						visible: true,
						inputValues: {
							code: data.data.code,
							name: data.data.name,
							description: data.data.description,
							sectionCode: data.data.section,
						},
						isMain: false,
					}),
				);
			});
		}
	};
	const checkRule = (mode: "edit" | "remove") => {
		if (!ruleEdit) {
			snackWrapper("error", "У вас не достаточно прав");
			return;
		}
		if (mode === "edit") {
			handleEditCode();
		} else {
			row.codes.length ? dispatch(setCode({ code: row.code, delete: false })) : dispatch(deleteCode(row.code));
		}
	};
	return (
		<div className={cn(styles.row, { [styles.endLine]: active && row.codes.length })}>
			<div key={row.code} className={styles.box}>
				<div
					className={cn(
						isMain ? styles.main : isEdit && row.codes.length ? styles.subLine : styles.subLine,
						outline(row.code, !!isMain),
						{
							[styles.active]: active && row.codes.length,
							[styles.selected]: isEdit && selectedRows.includes(row.code),
						},
					)}
					onClick={() => {
						if (isEdit && !row.codes.length) dispatch(selectRow(row.code));
						row.codes.length && setActive((prevState) => !prevState);
					}}>
					{!isMain && isEdit ? (
						// && !!row.codes.length
						<div className={styles.checkbox}>
							<NewCheckBox
								type="checkbox"
								checked={selectedRows.includes(row.code)}
								onChange={() => {
									dispatch(selectRow(row.code));
								}}
							/>
						</div>
					) : (
						<div></div>
					)}
					{/*{isEdit && !isMain && !row.codes.length?*/}
					{/*    <div className={styles.checkboxMain}>*/}
					{/*      <NewCheckBox*/}
					{/*          type="checkbox"*/}
					{/*          checked={selectedRows.includes(row.code)}*/}
					{/*          onChange={() => dispatch(selectRow(row.code))}*/}
					{/*      />*/}
					{/*    </div>:null*/}

					{/*}*/}

					{row.codes && row.codes.length ? <ArrowTopSvg className={styles.arrowTop} /> : <div></div>}
					<div className={cn(styles.row, { [styles.sectionCode]: isMain })}>{row.code}</div>
					<div className={cn(styles.row, { [styles.sectionName]: isMain })}>{row.name}</div>
					<div className={styles.row}>{row.description}</div>
					{!isEdit && (
						<ActionIconSvg
							ref={actionsRef}
							className={styles.actions}
							onClick={(e) => {
								e.stopPropagation();
								setActionsVisible((prevState) => !prevState);
							}}
						/>
					)}
				</div>

				{actionsVisible && (
					<DropSelect target={actionsRef.current} position="right">
						<div className={styles.actionsBox}>
							<div
								className={styles.action}
								onClick={() => {
									checkRule("remove");
								}}>
								<TrashCanSvg className={styles.deleteIcon} />
								Удалить
							</div>

							<div
								className={styles.action}
								onClick={() => {
									checkRule("edit");
								}}>
								<EditorIconSvg className={styles.editIcon} />
								Редактировать
							</div>
						</div>
					</DropSelect>
				)}

				{active &&
					row.codes.map((codes, index) => <BodyRow ruleEdit={ruleEdit} outline={outline} key={index} row={codes} />)}
			</div>

			{ruleEdit && code.code === row.code && (
				<ModalPortal
					title="Удаление невозможно"
					handleClose={() => dispatch(setCode({ code: "", delete: false }))}
					outSide={false}>
					<div className={styles.errorText}>
						Удаление невозможно т.к.
						<span className={styles.errorSpan}>
							{!code.delete ? "есть вложенные элементы" : "код используется в одной или нескольких организациях"}
						</span>
					</div>

					<Button full onClick={() => dispatch(setCode({ code: "", delete: false }))}>
						Понятно
					</Button>
				</ModalPortal>
			)}
		</div>
	);
};

export default BodyRow;
